"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSkip = exports.getQuerySingleEntity = exports.getParams = void 0;
exports.getParams = (filters, projection) => {
    return { filters, projection };
};
exports.getQuerySingleEntity = (entity, filters, projection) => {
    const params = exports.getParams(filters, projection);
    return { [entity]: params };
};
exports.getSkip = (pageIdx, nPerPage) => (pageIdx - 1) * nPerPage;
